import React, { FC } from 'react';

import Link from 'buyside/components/presentation/Link/link';
import RedactedDataPoint from 'buyside/components/presentation/AccessControl/redactedDataPoint';
import ReturnValue from 'buyside/components/presentation/ReturnValue/returnValue';

import separateWithDots from 'buyside/util/separateWithDots';
import { ideaUrl } from 'buyside/util/urlHelper';

import { HomePageTrendingIdeasQuery } from 'interfaces/graphql-typings';

import styles from './homePageTrendingIdeasStyles.scss';

const HomePageTrendingIdea: FC<NonNullable<
  NonNullable<
    NonNullable<NonNullable<HomePageTrendingIdeasQuery['trendingIdeas']>['edges']>[number]
  >['node']
>> = ({ id, positions, totalReturn }) => {
  return (
    <div className={styles.trendingIdea}>
      {positions[0].primarySymbol === 'Redacted' ? (
        <div className={styles.redactedTrendingIdea}>
          <RedactedDataPoint Wrapper="div" />
          <ReturnValue value={totalReturn} />
        </div>
      ) : (
        <Link to={ideaUrl(id)}>
          <div className={styles.assetSymbol}>
            {separateWithDots(positions.map(position => position.primarySymbol))}
          </div>
          <ReturnValue value={totalReturn} />
        </Link>
      )}
    </div>
  );
};

export default HomePageTrendingIdea;
